import React from 'react'
import Photo01 from '../assets/PalomaArteDeImpactar.png'
import Photo02 from '../assets/Design.png'
import Wt from '../components/botWhatsapp'

const Header = ({ children }) => {
    return (
        
        <div className='lg:px-0 px-5 lg:flex lg:justify-between'>
            <div>
                <div className=' lg:px-24 '>
                    <div className='flex items-center'>
                        <img className='Photo02Style' src={Photo02} alt='arteDeImpactar' />
                    </div>
                        
                    <div className='xl:flex  container02'>
                        <h1 className=' headerNameStyle'>PALOMA PATRICIA</h1>
                        <div>
                            <h1 className='headerSubTitle01'>PERSONAL E PROFISSIONAL</h1> 
                            <h1 className='headerSubTitle02'>COACH</h1>
                        </div>
                    </div>
                </div>
                <h2 className='lg:px-24 headerSubNameStyle'>A ARTE DE IMPACTAR</h2>
                <div className='lg:absolute wt py-2 w-16'>
                    <Wt /> 
                </div>
                <h1 className='px-8 headerTitleStyle'>Treinamento em Alta Performance</h1>
                <p className='px-8 headerP2Style'>2 horas Preço variado</p>
                <p className='px-8 headerP2Style'>Descubra o poder de sua mente e promova mundanças profundas em sua vida!</p>
                <p className='px-12 headerP1Style'>-Desperte sua inteligência emocional;</p>
                <p className='px-12 headerP1Style'>-Seja o lider de sua vida;</p>
                <p className='px-12 headerP1Style'>-Reprograme seus hábitos;</p>
                <p className='px-12 headerP1Style'>-Defina prioridades;</p>
                <p className='py-2'></p>
            </div>
            
            <img className='animasion1' src={Photo01} alt='PalomaArtDeImpactar' /> 
        </div>  
    )   
}
export default Header
